import React from 'react';
import Alert, { AlertTitle } from '../Alert';
import Text from '../Typography/Text';
import { Margin } from '../Spacing';
class ErrorBoundary extends React.Component {
  static defaultProps = {
    title: 'Unexpected Display Issue',
    description: 'We apologize for the inconvenience. Due to an unexpected issue, we are unable to display this content at the moment. Please refresh the page or try again later.',
    bordered: true,
    borderRadius: 'DEFAULT',
    padded: true
  };
  state = {
    hasError: false
  };
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      onError
    } = this.props;
    if (onError) {
      onError(error, errorInfo);
    }
  }
  render() {
    const {
      children,
      title,
      bordered,
      borderRadius,
      description,
      padded,
      marginProps
    } = this.props;
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement(Margin, marginProps, /*#__PURE__*/React.createElement(Alert, {
        borderRadius: borderRadius,
        displayBorders: bordered,
        severity: "error",
        padded: padded
      }, /*#__PURE__*/React.createElement(AlertTitle, null, title), /*#__PURE__*/React.createElement(Text, {
        as: "p"
      }, description)));
    }
    return children;
  }
}
export default ErrorBoundary;
//# sourceMappingURL=index.js.map